import { finalize } from 'rxjs/operators';
import { Component, Inject, Injector, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppComponentBase } from '@shared/app-component-base';
import { NotificationServiceProxy, NotificationType, UserNotification } from '@shared/service-proxies/service-proxies';
import { AppNotificationType } from '@shared/AppEnums';

@Component({
  selector: 'app-notification-detail-dialog',
  templateUrl: './notification-detail-dialog.component.html',
  styleUrls: ['./notification-detail-dialog.component.css']
})
export class NotificationDetailDialogComponent extends AppComponentBase implements OnInit {
  userNotification: UserNotification;
  notificationMessage: string;
  type: NotificationType;
  constructor(
    private injector: Injector,
    @Optional() @Inject(MAT_DIALOG_DATA) private notificationId: string,
    private _notificationService: NotificationServiceProxy,
    private _dialogRef: MatDialogRef<NotificationDetailDialogComponent>,
  ) {
    super(injector);
  }

  ngOnInit() {
    this.spinner.show()
    this._notificationService.getNotificationData(this.notificationId)
      .pipe(
        finalize(() => this.spinner.hide())
      )
      .subscribe(res => {
        this.userNotification = res;
        this.notificationMessage = res.notification.data.properties.Message;
        this.type = res.notification.data.properties.Type;
      })
  }
  getTitle() {
    if (this.type == AppNotificationType.General) {
      return this.l('GeneralNotification');
    }
    else if (this.type == AppNotificationType.Control) {
      return this.l('ControlNotification');
    }
    else if (this.type == AppNotificationType.Picking) {
      return this.l('PickingNotification');
    }
    else if (this.type == AppNotificationType.Placement) {
      return this.l('PlacementNotification');
    }
    else {
      return this.l('GeneralNotification');
    }
  }
  close(): void {
    this._dialogRef.close();
  }
}
